import React from "react";
import DropzoneComponent from "../../components/Dropzone";

const PhotosAdd = (props) => {
    return <DropzoneComponent />;
};

export default PhotosAdd;
